import React, { Fragment } from 'react';
import {
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  Label,
  Input,
  Spinner,
} from 'reactstrap';
import apiResponse from '../../../../services/apiResponse';
import Pie from '../Chart/Pie';
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import PunishmentListComponent from './PunishmentListComponent';
import IndexBloc from './../Blocs/IndexBloc';
import moment from 'moment';

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj['label'] = data[label];
    newObj['value'] = data[value];

    return newObj;
  });
};

class PunishmentComponent extends React.Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.state = {
      optionUnits: [],
      selectedUnit: null,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      punishmentChart: [
        { value: 335, name: 'Ringan' },
        { value: 10, name: 'Sedang' },
        { value: 5, name: 'Berat' },
      ],
      punishmentList: [],
      loadingPunishmentChart: true,
      loadingPunishmentList: true,
    };
  }

  loadData = () => {
    let query = {
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      work_unit: this.state.selectedUnit,
    };

    this.setState({
      loadingPunishmentChart: true,
      loadingPunishmentList: true,
    });

    this.indexBloc.fetchPunishmentChart(query);
    this.indexBloc.fetchPunishmentList(query);
  };

  componentDidMount() {
    this.indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              optionUnits: reformatOptions(
                response,
                'work_unit_name_tabs',
                'work_unit_name'
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchWorkUnit();

    this.indexBloc.punishmentChartChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              punishmentChart: response.group,
              loadingPunishmentChart: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.punishmentListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              punishmentList: response,
              loadingPunishmentList: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.loadData();
  }

  componentWillUnmount() {
    this.indexBloc.workUnitChannel?.unsubscribe();
    this.indexBloc.punishmentChartChannel?.unsubscribe();
    this.indexBloc.punishmentListChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Row>
          <Col md="5">
            <Row>
              <Col md="12">
                <Card
                  style={{
                    borderRadius: '20px',
                    boxShadow:
                      '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <CardBody>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Periode</Label>
                      <Col md="4">
                        <Input
                          name="start_date"
                          placeholder="Tanggal Mulai"
                          errorMessage="Masukkan Filter Tanggal"
                          type="date"
                          className="form-control"
                          onChange={(e) => {
                            this.setState({
                              startDate: e.target.value,
                            });
                            setTimeout(() => {
                              this.loadData();
                            }, 500);
                          }}
                          value={this.state.startDate}
                        />
                      </Col>
                      <Col md="5">
                        <Input
                          name="end_date"
                          placeholder="Tanggal Selesai"
                          errorMessage="Masukkan Tanggal Selesai"
                          type="date"
                          className="form-control"
                          onChange={(e) => {
                            this.setState({
                              endDate: e.target.value,
                            });
                            setTimeout(() => {
                              this.loadData();
                            }, 500);
                          }}
                          value={this.state.endDate}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Unit Kerja
                      </Label>
                      <Col md="9">
                        <CustomSelect
                          isAvForm={false}
                          options={this.state.optionUnits}
                          name="unit_kerja"
                          placeholder="Unit Kerja"
                          onChange={(v) => {
                            this.setState({
                              selectedUnit: v != null ? v.value : '',
                            });
                            setTimeout(() => {
                              this.loadData();
                            }, 500);
                          }}
                          isClearable={true}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col md="12">
                <Card
                  style={{
                    height: '360px',
                    borderRadius: '20px',
                    boxShadow:
                      '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <CardBody>
                    <CardTitle>Hukuman Disiplin Berdasarkan Kategori</CardTitle>
                    {this.state.loadingPunishmentChart === false ? (
                      <Pie options={this.state.punishmentChart} />
                    ) : (
                      <div
                        className="text-center"
                        style={{ marginTop: '90px' }}
                      >
                        <Spinner className="m-2" color="primary" />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col md="7">
            <Row>
              <Col md="12">
                <PunishmentListComponent
                  options={this.state.punishmentList}
                  loading={this.state.loadingPunishmentList}
                  height="530px"
                />
              </Col>
            </Row>
          </Col>
          <Col md="4"></Col>
        </Row>
      </Fragment>
    );
  }
}

export default PunishmentComponent;
